// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IOfferReactionSchema {
  /** Id объявления **/
  offerId: number;
  /** Реакция на рекомендованное объявление **/
  reaction?: EReaction;
}
export enum EReaction {
  /** Не нравится **/
  'Dislike' = 'dislike',
  /** Нравится **/
  'Like' = 'like',
}
